export default __webpack_public_path__ + "static/media/cathedralLogoHorizontal.eff0f45c.png";